// FIX FOR LOCALISATION CLICK PROPOGATION
let localiser=document.getElementById('localisation_switch');
localiser.addEventListener('click', function(e) {
  let instance=document.getElementById('l_options');
  if (instance.classList.contains('showme')) {
    instance.classList.remove('showme');
  } else {
    instance.classList.add('showme');
  }
});

// Navigation Level 3 fix
jQuery('ul#main-menu >li >ul >li.menu-item-has-children >a').click(function(e) {
  e.preventDefault();
  e.stopPropagation();
  jQuery(this).siblings('ul').toggleClass('show');
});
jQuery('ul#main-menu >li >a').click(function(e) {
  jQuery(this).siblings('ul').find('ul').removeClass('show');
});